import React from 'react';
import { Button, Text } from '@fragments';
import './index.scss';

/**
 * ButtonGroup component — a segmented control where the user selects one option.
 *
 * @param {Array}    options   - Array of { label, icon, value } objects
 * @param {string}   value     - Currently selected value
 * @param {function} onChange  - Callback called with the selected value
 * @param {string}   size      - "small" | "medium" | "large" (default: "medium")
 * @param {boolean}  grow      - Make the group fill its container and grow items equally
 * @param {string}   className - Extra class names
 */
export default function ButtonGroup({
  options = [],
  value,
  onChange,
  size = 'medium',
  grow = false,
  className = '',
}) {
  return (
    <div className={`BtnGroup_root BtnGroup_${size} ${grow ? 'BtnGroup_grow' : ''} ${className}`.trim()}>
      {options.map((option) => {
        const isActive = option.value === value;
        return (
          <Button
            key={option.value}
            variant={isActive ? undefined : 'text'}
            color={isActive ? 'inverse' : 'text'}
            size={size}
            preventLoading
            className={`BtnGroup_item ${isActive ? 'BtnGroup_active' : ''}`}
            onClick={() => onChange && onChange(option.value)}
            icon={option.label ? null : (option.icon || null)}
            startIcon={option.label ? (option.icon || null) : null}
          >
            {option.label && (
              <Text.span contrast={8} weight={500}>
                {option.label}
              </Text.span>
            )}
          </Button>
        );
      })}
    </div>
  );
}
